import { createReducer } from 'typesafe-actions';
import { creatorsListActions } from '~/features/creators-list/store/actions';
import { CreatorsListDto } from '~/models/creatorsList.dto';

export class State {
    creatorsList!: CreatorsListDto | null;
}

export const reducer = createReducer(new State()).handleAction(creatorsListActions.success, (state, { payload }) => ({
    ...state,
    creatorsList: { ...payload },
}));
